import React, {useEffect} from "react";

const EnvironmentNotFound = () => {

  useEffect(() => {
    localStorage.removeItem("preferredEnvironment");
  });

  
  return (
    <div id="login-container">
        <div className="container" >
          <div className="col-md-12">

            <div id="login-content">
            <div className="card card-container">
              
                <div id="content-title">Environment Not Found</div>
                <div>The requested environment does not exist or may have been removed.<br/><br/><a className="underline" href="https://main.risqui.nl/?redirected=true">Try logging in again</a></div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default EnvironmentNotFound;